<template>
  <div class="grupo-consolidado">
    <div class="card card-custom mb-6">
      <div class="card-header border-0 pt-6">
        <div class="card-title">
          <div>
            <h3 class="card-label mb-1">Painel consolidado</h3>
            <span class="text-muted font-size-sm">
              Visão somente leitura das empresas do grupo.
            </span>
          </div>
        </div>
        <div class="card-toolbar">
          <router-link
            :to="{ name: 'grupoEmpresa' }"
            class="btn btn-sm btn-light-primary"
          >
            <i class="fas fa-arrow-left mr-1"></i>
            Voltar ao grupo
          </router-link>
        </div>
      </div>

      <div class="card-body pt-4">
        <div v-if="carregandoInicial" class="text-center py-10">
          <span class="spinner spinner-primary"></span>
        </div>

        <template v-else-if="grupo">
          <div class="painel-filtros mb-6">
            <b-form @submit.prevent="carregarDashboard">
              <div class="d-flex flex-wrap align-items-end">
                <b-form-group
                  class="filtro-data mr-3 mb-0"
                  label="De"
                  label-for="consolidado-inicio"
                >
                  <b-form-input
                    id="consolidado-inicio"
                    v-model="filtros.inicio"
                    type="date"
                    required
                  />
                </b-form-group>
                <b-form-group
                  class="filtro-data mr-3 mb-0"
                  label="Até"
                  label-for="consolidado-fim"
                >
                  <b-form-input
                    id="consolidado-fim"
                    v-model="filtros.fim"
                    type="date"
                    :min="filtros.inicio"
                    required
                  />
                </b-form-group>
                <b-form-group
                  class="filtro-empresas mr-3 mb-0"
                  label="Empresas"
                >
                  <b-dropdown
                    variant="light"
                    menu-class="seletor-empresas-menu"
                    no-flip
                    block
                  >
                    <template #button-content>
                      <span
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <span class="text-truncate">
                          {{ resumoEmpresasSelecionadas }}
                        </span>
                        <i class="fas fa-chevron-down ml-3 font-size-xs"></i>
                      </span>
                    </template>
                    <b-dropdown-form @click.stop>
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <strong>Empresas incluídas</strong>
                        <span class="text-muted font-size-sm">
                          {{ filtros.empresas.length }}/{{
                            opcoesEmpresas.length
                          }}
                        </span>
                      </div>
                      <div class="seletor-empresas-lista">
                        <b-form-checkbox
                          v-for="empresa in opcoesEmpresas"
                          :key="empresa.value"
                          v-model="filtros.empresas"
                          :value="empresa.value"
                          class="seletor-empresa-item"
                        >
                          <span
                            class="d-flex align-items-center justify-content-between"
                          >
                            <span>{{ empresa.nome }}</span>
                            <small class="text-muted ml-4">
                              {{ empresa.tipo }}
                            </small>
                          </span>
                        </b-form-checkbox>
                      </div>
                      <div class="d-flex border-top pt-3 mt-3">
                        <button
                          type="button"
                          class="btn btn-xs btn-light-primary mr-2"
                          @click="selecionarTodas"
                        >
                          Todas
                        </button>
                        <button
                          type="button"
                          class="btn btn-xs btn-light"
                          @click="filtros.empresas = []"
                        >
                          Limpar
                        </button>
                      </div>
                    </b-dropdown-form>
                  </b-dropdown>
                </b-form-group>
                <button
                  type="submit"
                  class="btn btn-primary px-6"
                  :disabled="carregando || filtros.empresas.length === 0"
                  data-testid="atualizar-painel"
                >
                  <span
                    v-if="carregando"
                    class="spinner spinner-sm spinner-light mr-2"
                  ></span>
                  Atualizar
                </button>
              </div>
            </b-form>
            <small class="text-muted d-block mt-3">
              Vendas e financeiro respeitam o período. A aba Bancos apresenta o
              saldo atual das contas selecionadas.
            </small>
          </div>

          <div v-if="carregando" class="text-center py-10">
            <span class="spinner spinner-primary"></span>
          </div>

          <template v-else-if="dashboard">
            <div class="row">
              <div
                v-for="card in cards"
                :key="card.key"
                class="col-sm-6 col-xl-3 mb-5"
              >
                <div class="card card-custom h-100 painel-kpi">
                  <div class="card-body p-5">
                    <span class="text-muted font-weight-bold d-block mb-2">
                      {{ card.label }}
                    </span>
                    <strong
                      class="font-size-h3"
                      :class="card.className || 'text-dark'"
                    >
                      {{ formatarMoeda(card.valor) }}
                    </strong>
                    <small v-if="card.detalhe" class="d-block text-muted mt-2">
                      {{ card.detalhe }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-custom border mt-2">
              <div class="card-header border-0">
                <div class="card-title">
                  <div>
                    <h4 class="card-label mb-1">Relatórios consolidados</h4>
                    <span class="text-muted font-size-sm">
                      Comparativo por empresa no período selecionado.
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <b-tabs content-class="pt-5">
                  <b-tab title="Vendas" active>
                    <div class="d-flex justify-content-end mb-4">
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="exportarVendas"
                      >
                        <i class="fas fa-file-csv mr-1"></i>
                        Exportar vendas CSV
                      </button>
                    </div>
                    <div class="row mb-5">
                      <div class="col-xl-8 mb-5 mb-xl-0">
                        <div class="border rounded p-4 h-100">
                          <h5 class="mb-1">Faturamento por empresa</h5>
                          <span class="text-muted font-size-sm">
                            Comparação do valor fiscal no período.
                          </span>
                          <apexchart
                            type="bar"
                            height="360"
                            :options="graficoVendasOptions"
                            :series="graficoVendasSeries"
                          />
                        </div>
                      </div>
                      <div class="col-xl-4">
                        <div class="border rounded p-4 h-100">
                          <h5 class="mb-1">Participação no faturamento</h5>
                          <span class="text-muted font-size-sm">
                            Distribuição do total entre as empresas.
                          </span>
                          <apexchart
                            v-if="temFaturamento"
                            type="donut"
                            height="360"
                            :options="graficoParticipacaoOptions"
                            :series="graficoParticipacaoSeries"
                          />
                          <div v-else class="text-center text-muted py-15">
                            Sem faturamento no período selecionado.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-vertical-center">
                        <thead>
                          <tr>
                            <th>Empresa</th>
                            <th class="text-right">Vendas</th>
                            <th class="text-right">Faturamento</th>
                            <th class="text-right">Ticket médio</th>
                            <th class="text-right">Participação</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="empresa in relatorioVendas"
                            :key="empresa.id_empresa"
                          >
                            <td>
                              <strong class="d-block">
                                {{ empresa.nome }}
                              </strong>
                              <small class="text-muted">
                                {{ empresa.tipo }}
                              </small>
                            </td>
                            <td class="text-right">
                              {{ empresa.quantidade_vendas }}
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.faturamento) }}
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.ticket_medio) }}
                            </td>
                            <td class="text-right">
                              {{ formatarPercentual(empresa.participacao) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab title="Financeiro">
                    <div class="d-flex justify-content-end mb-4">
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="exportarFinanceiro"
                      >
                        <i class="fas fa-file-csv mr-1"></i>
                        Exportar financeiro CSV
                      </button>
                    </div>
                    <div class="row mb-5">
                      <div class="col-xl-6 mb-5 mb-xl-0">
                        <div class="border rounded p-4 h-100">
                          <h5 class="mb-1">Movimentação do período</h5>
                          <span class="text-muted font-size-sm">
                            Recebimentos, pagamentos e resultado por empresa.
                          </span>
                          <apexchart
                            type="bar"
                            height="360"
                            :options="graficoFinanceiroOptions"
                            :series="graficoFinanceiroSeries"
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="border rounded p-4 h-100">
                          <h5 class="mb-1">Contas em aberto</h5>
                          <span class="text-muted font-size-sm">
                            Valores a receber, a pagar e respectivos vencidos.
                          </span>
                          <apexchart
                            type="bar"
                            height="360"
                            :options="graficoContasOptions"
                            :series="graficoContasSeries"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-vertical-center">
                        <thead>
                          <tr>
                            <th>Empresa</th>
                            <th class="text-right">Recebido</th>
                            <th class="text-right">Pago</th>
                            <th class="text-right">Resultado</th>
                            <th class="text-right">A receber</th>
                            <th class="text-right">Receber vencido</th>
                            <th class="text-right">A pagar</th>
                            <th class="text-right">Pagar vencido</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="empresa in relatorioFinanceiro"
                            :key="empresa.id_empresa"
                          >
                            <td>
                              <strong class="d-block">
                                {{ empresa.nome }}
                              </strong>
                              <small class="text-muted">
                                {{ empresa.tipo }}
                              </small>
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.receitas_recebidas) }}
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.despesas_pagas) }}
                            </td>
                            <td
                              class="text-right font-weight-bold"
                              :class="
                                classeResultado(empresa.resultado_periodo)
                              "
                            >
                              {{ formatarMoeda(empresa.resultado_periodo) }}
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.contas_receber) }}
                            </td>
                            <td class="text-right text-danger">
                              {{
                                formatarMoeda(empresa.contas_receber_vencidas)
                              }}
                            </td>
                            <td class="text-right">
                              {{ formatarMoeda(empresa.contas_pagar) }}
                            </td>
                            <td class="text-right text-danger">
                              {{ formatarMoeda(empresa.contas_pagar_vencidas) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab title="Bancos">
                    <div
                      class="d-flex flex-wrap align-items-center justify-content-between mb-4"
                    >
                      <div>
                        <strong class="d-block">Saldos atuais</strong>
                        <span class="text-muted font-size-sm">
                          Posição atual das contas bancárias, independente do
                          período.
                        </span>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="exportarBancos"
                      >
                        <i class="fas fa-file-csv mr-1"></i>
                        Exportar bancos CSV
                      </button>
                    </div>

                    <div class="row mb-6">
                      <div class="col-xl-8 mb-5 mb-xl-0">
                        <div class="painel-grafico h-100">
                          <h5 class="mb-1">Saldo bancário por empresa</h5>
                          <span class="text-muted font-size-sm">
                            Soma das contas cadastradas em cada empresa.
                          </span>
                          <apexchart
                            v-if="relatorioBancosPorEmpresa.length"
                            type="bar"
                            height="360"
                            :options="graficoBancosOptions"
                            :series="graficoBancosSeries"
                          />
                          <div v-else class="text-center text-muted py-15">
                            Nenhuma conta bancária cadastrada.
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-4">
                        <div class="resumo-bancos h-100">
                          <span
                            class="text-muted font-weight-bold d-block mb-2"
                          >
                            Saldo bancário consolidado
                          </span>
                          <strong
                            class="font-size-h1 d-block mb-6"
                            :class="classeResultado(saldoBancosTotal)"
                          >
                            {{ formatarMoeda(saldoBancosTotal) }}
                          </strong>
                          <div
                            class="d-flex justify-content-between border-top pt-4 mb-3"
                          >
                            <span class="text-muted">Contas cadastradas</span>
                            <strong>{{ relatorioBancos.length }}</strong>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span class="text-muted"
                              >Contas com saldo negativo</span
                            >
                            <strong
                              :class="
                                contasBancariasNegativas ? 'text-danger' : ''
                              "
                            >
                              {{ contasBancariasNegativas }}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="relatorioBancos.length" class="table-responsive">
                      <table class="table table-vertical-center">
                        <thead>
                          <tr>
                            <th>Empresa</th>
                            <th>Banco/conta</th>
                            <th>Agência</th>
                            <th>Conta</th>
                            <th class="text-right">Saldo atual</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="banco in relatorioBancos"
                            :key="banco.id_banco"
                          >
                            <td>
                              <strong class="d-block">
                                {{ banco.empresa }}
                              </strong>
                              <small class="text-muted">
                                {{ banco.empresa_tipo }}
                              </small>
                            </td>
                            <td>
                              <strong>{{ banco.nome }}</strong>
                              <small
                                v-if="banco.codigo_banco"
                                class="text-muted ml-2"
                              >
                                Cód. {{ banco.codigo_banco }}
                              </small>
                            </td>
                            <td>{{ banco.agencia || "—" }}</td>
                            <td>{{ banco.conta || "—" }}</td>
                            <td
                              class="text-right font-weight-bold text-nowrap"
                              :class="classeResultado(banco.saldo)"
                            >
                              {{ formatarMoeda(banco.saldo) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="alert alert-light-info mb-0">
                      Nenhuma conta bancária encontrada nas empresas
                      selecionadas.
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </template>
        </template>

        <div v-else class="alert alert-light-warning mb-0">
          Acesse a empresa matriz e configure um grupo empresarial antes de
          consultar o painel consolidado.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrupoEmpresaConsolidado",
  data() {
    const hoje = new Date();
    const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    return {
      carregandoInicial: true,
      carregando: false,
      grupo: null,
      dashboard: null,
      filtros: {
        inicio: this.formatarDataInput(inicioMes),
        fim: this.formatarDataInput(hoje),
        empresas: [],
      },
    };
  },
  computed: {
    opcoesEmpresas() {
      return (this.grupo?.membros || [])
        .filter((membro) => membro.ativo !== false && membro.empresa)
        .map((membro) => ({
          value: Number(membro.id_empresa),
          text: `${this.nomeEmpresa(membro.empresa)} (${membro.tipo})`,
          nome: this.nomeEmpresa(membro.empresa),
          tipo: membro.tipo,
        }));
    },
    resumoEmpresasSelecionadas() {
      const quantidade = this.filtros.empresas.length;
      if (quantidade === 0) return "Nenhuma empresa";
      if (quantidade === this.opcoesEmpresas.length) return "Todas as empresas";
      if (quantidade === 1) {
        return (
          this.opcoesEmpresas.find(
            (empresa) => empresa.value === this.filtros.empresas[0]
          )?.nome || "1 empresa"
        );
      }

      return `${quantidade} empresas selecionadas`;
    },
    cards() {
      const totais = this.dashboard?.totais || {};

      return [
        {
          key: "faturamento",
          label: "Faturamento Total",
          valor: totais.faturamento,
          detalhe: `${totais.quantidade_vendas || 0} venda(s)`,
        },
        {
          key: "resultado",
          label: "Resultado do período",
          valor: totais.resultado_periodo,
          className: this.classeResultado(totais.resultado_periodo),
          detalhe: `${this.formatarMoeda(
            totais.receitas_recebidas
          )} recebido · ${this.formatarMoeda(totais.despesas_pagas)} pago`,
        },
        {
          key: "receber",
          label: "Contas a receber",
          valor: totais.contas_receber,
          detalhe: `${this.formatarMoeda(
            totais.contas_receber_vencidas
          )} vencidos`,
        },
        {
          key: "pagar",
          label: "Contas a pagar",
          valor: totais.contas_pagar,
          detalhe: `${this.formatarMoeda(
            totais.contas_pagar_vencidas
          )} vencidos`,
        },
      ];
    },
    relatorioVendas() {
      const faturamentoTotal = Number(this.dashboard?.totais?.faturamento || 0);

      return (this.dashboard?.empresas || []).map((empresa) => {
        const faturamento = Number(empresa.metricas?.faturamento || 0);
        const quantidade = Number(empresa.metricas?.quantidade_vendas || 0);

        return {
          id_empresa: empresa.id_empresa,
          nome: this.nomeEmpresa(empresa),
          tipo: empresa.tipo,
          quantidade_vendas: quantidade,
          faturamento,
          ticket_medio: quantidade > 0 ? faturamento / quantidade : 0,
          participacao:
            faturamentoTotal > 0 ? (faturamento / faturamentoTotal) * 100 : 0,
        };
      });
    },
    relatorioFinanceiro() {
      return (this.dashboard?.empresas || []).map((empresa) => ({
        id_empresa: empresa.id_empresa,
        nome: this.nomeEmpresa(empresa),
        tipo: empresa.tipo,
        receitas_recebidas: Number(empresa.metricas?.receitas_recebidas || 0),
        despesas_pagas: Number(empresa.metricas?.despesas_pagas || 0),
        resultado_periodo: Number(empresa.metricas?.resultado_periodo || 0),
        contas_receber: Number(empresa.metricas?.contas_receber || 0),
        contas_receber_vencidas: Number(
          empresa.metricas?.contas_receber_vencidas || 0
        ),
        contas_pagar: Number(empresa.metricas?.contas_pagar || 0),
        contas_pagar_vencidas: Number(
          empresa.metricas?.contas_pagar_vencidas || 0
        ),
      }));
    },
    relatorioBancos() {
      return (this.dashboard?.bancos || [])
        .map((banco) => ({
          id_banco: Number(banco.id_banco),
          id_empresa: Number(banco.id_empresa),
          empresa: this.nomeEmpresa(banco.empresa),
          empresa_tipo: banco.empresa?.tipo || "",
          nome: banco.nome,
          codigo_banco: banco.codigo_banco,
          agencia: banco.agencia,
          conta: banco.conta,
          tipo: banco.tipo,
          saldo: Number(banco.saldo || 0),
        }))
        .sort((a, b) =>
          `${a.empresa}-${a.nome}`.localeCompare(`${b.empresa}-${b.nome}`)
        );
    },
    relatorioBancosPorEmpresa() {
      return (this.dashboard?.empresas || []).map((empresa) => ({
        id_empresa: Number(empresa.id_empresa),
        nome: this.nomeEmpresa(empresa),
        saldo: Number(empresa.metricas?.saldo_bancos || 0),
      }));
    },
    saldoBancosTotal() {
      return Number(this.dashboard?.totais?.saldo_bancos || 0);
    },
    contasBancariasNegativas() {
      return this.relatorioBancos.filter((banco) => banco.saldo < 0).length;
    },
    categoriasGraficos() {
      return this.relatorioVendas.map((empresa) => empresa.nome);
    },
    temFaturamento() {
      return this.relatorioVendas.some((empresa) => empresa.faturamento > 0);
    },
    graficoVendasSeries() {
      return [
        {
          name: "Faturamento",
          data: this.relatorioVendas.map((empresa) => empresa.faturamento),
        },
      ];
    },
    graficoVendasOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, ["#ee7361"]);
    },
    graficoParticipacaoSeries() {
      return this.relatorioVendas.map((empresa) => empresa.faturamento);
    },
    graficoParticipacaoOptions() {
      return {
        chart: {
          toolbar: { show: false },
          animations: { enabled: false },
          fontFamily: "inherit",
        },
        labels: this.categoriasGraficos,
        colors: ["#ee7361", "#3699ff", "#1bc5bd", "#8950fc", "#ffa800"],
        dataLabels: {
          formatter: (valor) => this.formatarPercentual(valor),
        },
        legend: {
          position: "bottom",
          fontFamily: "inherit",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "62%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  formatter: () =>
                    this.formatarMoeda(this.dashboard?.totais?.faturamento),
                },
              },
            },
          },
        },
        tooltip: {
          y: { formatter: (valor) => this.formatarMoeda(valor) },
        },
      };
    },
    graficoFinanceiroSeries() {
      return [
        {
          name: "Recebido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.receitas_recebidas
          ),
        },
        {
          name: "Pago",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.despesas_pagas
          ),
        },
        {
          name: "Resultado",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.resultado_periodo
          ),
        },
      ];
    },
    graficoFinanceiroOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, [
        "#1bc5bd",
        "#f64e60",
        "#3699ff",
      ]);
    },
    graficoContasSeries() {
      return [
        {
          name: "A receber",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_receber
          ),
        },
        {
          name: "Receber vencido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_receber_vencidas
          ),
        },
        {
          name: "A pagar",
          data: this.relatorioFinanceiro.map((empresa) => empresa.contas_pagar),
        },
        {
          name: "Pagar vencido",
          data: this.relatorioFinanceiro.map(
            (empresa) => empresa.contas_pagar_vencidas
          ),
        },
      ];
    },
    graficoContasOptions() {
      return this.opcoesGraficoBarras(this.categoriasGraficos, [
        "#1bc5bd",
        "#ffa800",
        "#8950fc",
        "#f64e60",
      ]);
    },
    graficoBancosSeries() {
      return [
        {
          name: "Saldo atual",
          data: this.relatorioBancosPorEmpresa.map((empresa) => empresa.saldo),
        },
      ];
    },
    graficoBancosOptions() {
      return this.opcoesGraficoBarras(
        this.relatorioBancosPorEmpresa.map((empresa) => empresa.nome),
        ["#3699ff"]
      );
    },
  },
  methods: {
    formatarDataInput(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa}`
      );
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor || 0));
    },
    formatarPercentual(valor) {
      return `${Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}%`;
    },
    formatarMoedaCompacta(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        notation: "compact",
        maximumFractionDigits: 1,
      }).format(Number(valor || 0));
    },
    opcoesGraficoBarras(categorias, cores) {
      return {
        chart: {
          toolbar: { show: false },
          animations: { enabled: false },
          fontFamily: "inherit",
        },
        colors: cores,
        dataLabels: { enabled: false },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: "58%",
          },
        },
        xaxis: {
          categories: categorias,
          labels: {
            rotate: -25,
            trim: true,
          },
        },
        yaxis: {
          labels: {
            formatter: (valor) => this.formatarMoedaCompacta(valor),
          },
        },
        legend: {
          position: "bottom",
          fontFamily: "inherit",
        },
        grid: { borderColor: "#ebedf3" },
        tooltip: {
          y: { formatter: (valor) => this.formatarMoeda(valor) },
        },
      };
    },
    classeResultado(valor) {
      return Number(valor || 0) < 0 ? "text-danger" : "text-success";
    },
    selecionarTodas() {
      this.filtros.empresas = this.opcoesEmpresas.map((opcao) => opcao.value);
    },
    exportarVendas() {
      const linhas = this.relatorioVendas.map((empresa) => [
        empresa.nome,
        empresa.tipo,
        empresa.quantidade_vendas,
        empresa.faturamento,
        empresa.ticket_medio,
        empresa.participacao,
      ]);

      this.exportarCsv(
        "vendas",
        [
          "Empresa",
          "Tipo",
          "Quantidade de vendas",
          "Faturamento",
          "Ticket médio",
          "Participação (%)",
        ],
        linhas
      );
    },
    exportarFinanceiro() {
      const linhas = this.relatorioFinanceiro.map((empresa) => [
        empresa.nome,
        empresa.tipo,
        empresa.receitas_recebidas,
        empresa.despesas_pagas,
        empresa.resultado_periodo,
        empresa.contas_receber,
        empresa.contas_receber_vencidas,
        empresa.contas_pagar,
        empresa.contas_pagar_vencidas,
      ]);

      this.exportarCsv(
        "financeiro",
        [
          "Empresa",
          "Tipo",
          "Receitas recebidas",
          "Despesas pagas",
          "Resultado do período",
          "Contas a receber",
          "Contas a receber vencidas",
          "Contas a pagar",
          "Contas a pagar vencidas",
        ],
        linhas
      );
    },
    exportarBancos() {
      const linhas = this.relatorioBancos.map((banco) => [
        banco.empresa,
        banco.empresa_tipo,
        banco.nome,
        banco.codigo_banco,
        banco.tipo,
        banco.agencia,
        banco.conta,
        banco.saldo,
      ]);

      this.exportarCsv(
        "bancos",
        [
          "Empresa",
          "Tipo da empresa",
          "Banco/conta",
          "Código do banco",
          "Tipo da conta",
          "Agência",
          "Conta",
          "Saldo atual",
        ],
        linhas
      );
    },
    exportarCsv(tipo, cabecalho, linhas) {
      const escapar = (valor) => `"${String(valor ?? "").replace(/"/g, '""')}"`;
      const conteudo = [cabecalho, ...linhas]
        .map((linha) => linha.map(escapar).join(";"))
        .join("\n");
      const blob = new Blob([`\uFEFF${conteudo}`], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `grupo_${tipo}_${this.filtros.inicio}_${this.filtros.fim}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          this.selecionarTodas();
          await this.carregarDashboard();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarDashboard() {
      if (!this.grupo?.id_grupo_empresa || this.filtros.empresas.length === 0) {
        return;
      }

      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/dashboard`,
          {
            params: {
              inicio: this.filtros.inicio,
              fim: this.filtros.fim,
              empresas: this.filtros.empresas,
            },
          }
        );
        this.dashboard = data?.data || null;
      } finally {
        this.carregando = false;
      }
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
</script>

<style scoped>
.painel-filtros {
  background: #f5f8fa;
  border: 1px solid #ebedf3;
  border-radius: 0.65rem;
  padding: 1.25rem;
}

.filtro-data {
  width: 165px;
}

.filtro-empresas {
  min-width: 280px;
}

.painel-kpi {
  border: 1px solid #edf0f5;
  box-shadow: 0 7px 18px rgba(31, 45, 61, 0.06);
}

.painel-grafico,
.resumo-bancos {
  border: 1px solid #ebedf3;
  border-radius: 0.65rem;
  padding: 1.5rem;
}

.resumo-bancos {
  background: linear-gradient(145deg, #f5faff, #ffffff);
}

.seletor-empresas-lista {
  max-height: 260px;
  overflow-y: auto;
}

.seletor-empresa-item {
  border-radius: 0.45rem;
  margin-bottom: 0.35rem;
  padding: 0.65rem 0.75rem 0.65rem 2rem;
}

.seletor-empresa-item:hover {
  background: #f3f6f9;
}

.grupo-consolidado .table td,
.grupo-consolidado .table th {
  vertical-align: middle;
}

@media (max-width: 767.98px) {
  .filtro-data,
  .filtro-empresas {
    margin-bottom: 1rem !important;
    margin-right: 0 !important;
    width: 100%;
  }
}
</style>

<style>
.seletor-empresas-menu {
  min-width: 330px;
  padding: 0.5rem;
}
</style>
